export default {
  dbi_pc_console_metric_type_sales: '收入和销量',
  dbi_pc_console_metric_type_pcu_acu: 'PCU/ACU',
  dbi_pc_console_metric_type_mau: 'MAU',
  dbi_pc_console_metric_type_dau: 'DAU',
  dbi_pc_console_metric_type_engagement: '活跃度',
  dbi_pc_console_metric_type_wishlist_follows: '愿望单与关注',
  dbi_pc_console_metric_type_price_reviews: '价格与 Steam 评论',
  dbi_pc_console_metric_type_retention: '留存',
  dbi_pc_console_metric_type_no_update: '无更新',
  // 这块用dbi_metric为前缀， 后面使用value值
  dbi_metric_digitalRevenue: '线上收入(美元)',
  dbi_metric_usdigitalRevenue: '美国线上收入(美元)',
  dbi_metric_digitalRevenueNoDo: '线上收入',
  dbi_metric_digital_units: '线上销量',
  dbi_metric_units: '销量',
  dbi_metric_digitalARPPU: '付费玩家人均线上消费额(美元)(仅美国)',
  // dbi_metric_ast: '单笔交易消费均值（美元）',
  dbi_metric_ast: '平均单笔交易消费额',
  dbi_metric_steam_est_revenue: 'Steam本体收入(美元)',
  dbi_metric_est_revenue: '本体收入(美元)',
  dbi_metric_previous_mau: '上月月活跃玩家数',
  dbi_metric_added_mau: '月回流及新进玩家数',
  dbi_metric_new_mau: '月新进玩家数',
  dbi_metric_new_dau: '日新进玩家数',
  dbi_metric_retained_mau: '月留存玩家数',
  dbi_metric_churned_mau: '月流失玩家数',
  dbi_metric_cumulative_revenue: '累计收入(美元)',
  dbi_metric_est_units: 'Steam销量',
  dbi_metric_est_price: 'Steam价格',
  dbi_metric_player_share: '玩家份额占比',
  dbi_metric_mau_growth: '月活增长',
  dbi_metric_mau_new: '新增月活',
  dbi_metric_mau_returning: '月获客',
  // dbi_metric_lifetime_player: '游戏总玩家数',
  dbi_metric_lifetime_player: '总注册数',
  dbi_metric_avg_daily_playtime: '天平均游玩时长（分）',
  dbi_metric_avg_daily_sessions: '天平均登入次数',
  dbi_metric_avg_days_played: '平均游玩天数',
  dbi_metric_avg_monthly_playtime: '月平均游玩时长（小时）',
  dbi_metric_acquisition_rate: '买量占比',
  dbi_metric_avg_monthly_sessions: '月平均登入次数',
  dbi_metric_avg_playtime_per_session: '每次登入平均游玩时长（分）',
  dbi_metric_stickiness: '玩家粘性',
  dbi_metric_total_hours: '总时长',
  dbi_metric_time_spent_0H: '游玩时长 0-1 小时',
  dbi_metric_time_spent_1H: '游玩时长 1-5 小时',
  dbi_metric_time_spent_5H: '游玩时长 5-10 小时',
  dbi_metric_time_spent_10H: '游玩时长 10-25 小时',
  dbi_metric_time_spent_25H: '游玩时长 25-50 小时',
  dbi_metric_time_spent_50H: '游玩时长 >50 小时',
  dbi_metric_avg_daily_playtime_min: '平均每日游戏时间（分钟）',
  dbi_metric_avg_daily_sessions2: '平均每天登入次数',
  dbi_metric_avg_days_played2: '平均游戏天数',
  dbi_metric_avg_playtime_per_session_min: '平均每次登入游戏时间',
  dbi_metric_avg_monthly_sessions2: '平均每月登入次数',
  dbi_metric_avg_monthly_playtime_hour: '平均每月游戏时间（小时）',
  dbi_metric_avg_dailly_playtime_hour: '日平均游玩时长（小时）',
  dbi_metric_daily_wishlist: '每天新增愿望单人数',
  dbi_metric_lifetime_wishlist: '总愿望单人数',
  dbi_metric_steam_daily_wishlist: 'Steam每天新增愿望单人数',
  dbi_metric_steam_lifetime_wishlist: 'Steam总愿望单人数',
  // Gamalytic Steam指标专用国际化key
  dbi_metric_gamalytic_steam_est_revenue: 'Steam收入(美元)',
  dbi_metric_gamalytic_est_revenue: 'Steam收入(美元)',
  dbi_metric_gamalytic_steam_cumulative_premium_revenue: 'Steam累计收入(美元)',
  dbi_metric_gamalytic_jptb_cumulative_revenue_trends: 'Steam累计收入(美元)',
  dbi_metric_gamalytic_est_units: 'Steam销量',
  dbi_metric_gamalytic_steam_cumulative_units: 'Steam累计销量',
  dbi_metric_gamalytic_steam_pcu: 'Steam PCU',
  dbi_metric_gamalytic_steam_acu: 'Steam ACU',
  dbi_metric_gamalytic_steam_followers: 'Steam关注人数',
  dbi_metric_gamalytic_steam_reviews: 'Steam评论数量',
  dbi_metric_gamalytic_steam_total_reviews: 'Steam总评论数量',
  dbi_metric_gamalytic_est_price: 'Steam价格(美元)',
  dbi_metric_gamalytic_weighted_price: 'Steam加权价格',
  dbi_metric_gamalytic_lifetime_weighted_price_trends: 'Steam全生命周期加权价格(美元)',
  dbi_metric_gamalytic_players_by_country: 'Steam玩家国家分布',
  dbi_metric_gamalytic_steam_daily_wishlist: 'Steam每天新增愿望单人数',
  dbi_metric_gamalytic_steam_lifetime_wishlist: 'Steam总愿望单人数',
  dbi_metric_gamalytic_playtime_steam: 'Steam平均游玩时间(小时)',
  dbi_metric_gamalytic_followers: 'Steam总关注人数',
  // Alinea Steam指标专用国际化key
  dbi_metric_alinea_steam_est_revenue: 'Steam收入(美元)',
  dbi_metric_alinea_est_revenue: 'Steam收入(美元)',
  dbi_metric_alinea_steam_cumulative_premium_revenue: 'Steam累计收入(美元)',
  dbi_metric_alinea_steam_cumulative_revenue: 'Steam累计收入(美元)',
  dbi_metric_alinea_jptb_cumulative_revenue_trends: 'Steam累计收入(美元)',
  dbi_metric_alinea_est_units: 'Steam销量',
  dbi_metric_alinea_steam_cumulative_units: 'Steam累计销量',
  dbi_metric_alinea_steam_pcu: 'Steam PCU',
  dbi_metric_alinea_steam_acu: 'Steam ACU',
  dbi_metric_alinea_steam_followers: 'Steam关注人数',
  dbi_metric_alinea_steam_reviews: 'Steam评论数量',
  dbi_metric_alinea_steam_total_reviews: 'Steam总评论数量',
  dbi_metric_alinea_steam_players: 'Steam玩家数',
  dbi_metric_alinea_steam_total_players: 'Steam总玩家数',
  dbi_metric_alinea_steam_positive_reviews: 'Steam好评数',
  dbi_metric_alinea_steam_total_positive_reviews: 'Steam总好评数',
  dbi_metric_alinea_est_price: 'Steam价格(美元)',
  dbi_metric_alinea_weighted_price: 'Steam加权价格',
  dbi_metric_alinea_lifetime_weighted_price_trends: 'Steam全生命周期加权价格(美元)',
  dbi_metric_alinea_players_by_country: 'Steam玩家国家分布',
  dbi_metric_alinea_wishlists_by_country: 'Steam分国家愿望单数量',
  dbi_metric_alinea_steam_daily_wishlist: 'Steam每天新增愿望单人数',
  dbi_metric_alinea_steam_lifetime_wishlist: 'Steam总愿望单人数',
  dbi_metric_alinea_dau: '日活跃玩家数',
  dbi_metric_alinea_mau: '月活跃玩家数',
  dbi_metric_alinea_playtime_steam: 'Steam平均游玩时间(分钟)',
  dbi_metric_alinea_followers: 'Steam总关注人数',
  // Alinea PlayStation 指标
  dbi_metric_alinea_ps_revenue: 'PS 收入',
  dbi_metric_alinea_ps_revenue_total: 'PS 累计收入',
  dbi_metric_alinea_ps_units: 'PS 销量',
  dbi_metric_alinea_ps_units_total: 'PS 累计销量',
  dbi_metric_alinea_ps_lifetime_players: 'PS 玩家数',
  dbi_metric_alinea_ps_plus_total_players: 'PS 总玩家数',
  dbi_metric_alinea_ps_game_pass_players: 'PS Game Pass玩家数',
  dbi_metric_alinea_ps_game_pass_players_total: 'PS Game Pass总玩家数',
  dbi_metric_alinea_ps_dau: 'PS 日活跃用户数',
  dbi_metric_alinea_ps_mau: 'PS 月活跃用户数',
  dbi_metric_alinea_ps_players_by_country: 'PS 玩家国家分布',
  dbi_metric_alinea_ps_price: 'PS 售价',
  // Alinea Xbox 指标
  dbi_metric_alinea_xbox_revenue: 'Xbox 收入',
  dbi_metric_alinea_xbox_revenue_total: 'Xbox 累计收入',
  dbi_metric_alinea_xbox_units: 'Xbox 销量',
  dbi_metric_alinea_xbox_units_total: 'Xbox 累计销量',
  dbi_metric_alinea_xbox_players: 'Xbox 玩家数',
  dbi_metric_alinea_xbox_game_pass_total_players: 'Xbox 总玩家数',
  dbi_metric_alinea_xbox_game_pass_players: 'Xbox Game Pass 玩家数',
  dbi_metric_alinea_xbox_game_pass_players_total: 'Xbox Game Pass 总玩家数',
  dbi_metric_alinea_xbox_dau: 'Xbox 日活跃用户数',
  dbi_metric_alinea_xbox_mau: 'Xbox 月活跃用户数',
  dbi_metric_alinea_xbox_price: 'Xbox 售价',
  dbi_metric_rolling_d1: 'D1滚动留存',
  dbi_metric_rolling_d7: 'D7滚动留存',
  dbi_metric_rolling_d14: 'D14滚动留存',
  dbi_metric_rolling_d28: 'D28滚动留存',
  dbi_metric_rolling_d60: 'D60滚动留存',
  dbi_metric_monthly_rolling_d1: '月度D1滚动留存',
  dbi_metric_monthly_rolling_d7: '月度D7滚动留存',
  dbi_metric_monthly_rolling_d14: '月度D14滚动留存',
  dbi_metric_monthly_rolling_d28: '月度D28滚动留存',
  dbi_metric_monthly_rolling_d60: '月度D60滚动留存',

  // dbi_metric_avg_mau: 'Avg MAU',//TODO
  dbi_metric_jpseg_sales: '选中时间段内的销售额',
  dbi_metric_jpseg_revenue: '选中时间段内的收入',
  dbi_metric_jpseg_cumulative_sales: '累计销量',
  dbi_metric_jpseg_cumulative_revenue: '累计收入',
  dbi_metric_jpseg_price: '价格',
  dbi_metric_jptb_sales: '选中时间段内的销售额',
  dbi_metric_jptb_revenue: '选中时间段内的收入（美元）',
  dbi_metric_jptb_sales_latest_week: '最近一周销售额',
  dbi_metric_jptb_revenue_latest_week: '最近一周收入',
  dbi_metric_jptb_cumulative_sales: '最近一周累计销量',
  dbi_metric_jptb_cumulative_revenue: '最近一周累计收入（美元）',
  dbi_label_metric_est_revenue: '估算收入',
  dbi_label_metric_est_units: '销量',
  dbi_metric_jptb_price: '价格（美元）',
  dbi_metric_famitsu_price: '法米通价格（美元）',
  dbi_metric_physical_revenue: '零售收入(美元)',
  dbi_metric_usphysical_revenue: '美国零售收入(美元)',
  dbi_metric_physical_revenue1: '零售收入',
  dbi_metric_pcu: 'PCU',
  dbi_metric_acu: 'ACU',
  dbi_metric_avgplayers: '平均玩家数量',
  dbi_metric_rank: 'Rank',
  dbi_metric_dau: '日活跃玩家数',
  dbi_metric_wau: '周活跃玩家数',
  dbi_metric_mau: '月活跃玩家数',
  dbi_metric_revenue: '收入',
  dbi_metric_downloads: '下载量',
  dbi_metric_acquisition: '获客%',
  dbi_metric_churn: '流失%',
  dbi_metric_engagement: '参与度',
  dbi_metric_engagement_active: '活跃',
  dbi_metric_engagement_active_level: '活跃度',
  dbi_metric_churn_acquisition: '流失/获客',
  dbi_metric_atime_spent_0H: '游玩时长',
  dbi_metric_retention: '留存',
  dbi_metric_retention_d2: '留存 D2',
  dbi_metric_retention_d3: '留存 D3',
  dbi_metric_retention_d7: '留存 D7',
  dbi_metric_retention_d15: '留存 D15',
  dbi_metric_retention_d31: '留存 D31',
  dbi_KPIOverview_d1: '留存',
  dbi_metric_ampere_d1: 'D1',
  dbi_metric_ampere_d7: 'D7',
  dbi_metric_ampere_d14: 'D14',
  dbi_metric_ampere_d28: 'D28',
  dbi_metric_ampere_d60: 'D60',
  dbi_metric_monthly_ampere_d1: '月度 D1',
  dbi_metric_monthly_ampere_d7: '月度 D7',
  dbi_metric_monthly_ampere_d14: '月度 D14',
  dbi_metric_monthly_ampere_d28: '月度 D28',
  dbi_metric_monthly_ampere_d60: '月度 D60',
  dbi__metric_store_rank_top_seller: '愿望单榜',
  dbi__metric_store_rank_top_seller_overview: '热销榜排名',
  dbi__metric_store_rank_top_wishlist: '愿望单榜',
  dbi__metric_all_reviews: '全部评论',
  dbi_metric_price_dol: '价格(美元)',
  dbi_metric_lifetime_revenue: '游戏总收入(美元)',
  dbi_metric_d1_after_release_revenue: '上线首日游戏总收入(美元)',
  dbi_metric_w1_after_release_revenue: '上线首周游戏总收入(美元)',
  dbi_metric_m1_after_release_revenue: '上线首月游戏总收入(美元)',
  dbi_metric__y1_after_release_revenue: '上线首年游戏总收入(美元)',
  dbi_metric_y1_fter_ea_revenue: 'EA首年游戏总收入(美元)',
  dbi_metric_last_month_Revenue: '上个月美国线上收入(美元)',

  dbi_metric_lifetime_full_units: '游戏本体总销量',
  dbi_metric_d1_after_release_full_units: '上线首日游戏本体总销量',
  dbi_metric_w1_after_release_full_units: '上线首周游戏本体总销量',
  dbi_metric_m1_after_release_full_units: '上线首月游戏本体总销量',
  dbi_metric_y1_after_release_full_units: '上线首年游戏本体总销量',
  dbi_metric_y1_after_ea_full_units: 'EA首年游戏本体总销量',
  dbi_metric_last_month_full_units: '上个月游戏本体美国线上销量',

  dbi_metric_y1_after_ea_definition: '指游戏进入抢先体验阶段后的第一个完整自然年',
  dbi_metric_m1_after_release_definition: '含预购期内所有预购收入',
  dbi_metric_est_cumulative_units: '累计销量',
  dbi_metric_weighted_price: '加权价格(美元)',
  dbi_metric_lifetime_weighted_price: '全生命周期加权价格(美元)',
  dbi_metric_players_by_country: '玩家市场分布',
  dbi_metric_playtime: '平均游玩时长(分钟)',
  dbi_metric_followers: '总关注量',

  dbi_metric_rpd_asfor: `截至 {time} 的零售价格(美元)`,
  dbi_metric_cumulative_downloads: `累计下载`,
  dbi_metric_cumulative_revenue_$: '累计收入(美元)',
  dbi_metric_hourswatched: `观看时长(小时)`,
  dbi_metric_hourswatched_simple: '观看时长',
  dbi_metric_peakccv: `直播观众峰值`,
  dbi_metric_avgccv: `直播观众平均值`,
  dbi_metric_airtime: `直播时长(小时)`,
  dbi_metric_airtime_simple: `直播时长`,
  dbi_metric_digital_arpu_$: '线上付费玩家人均平均消费（美元）',
  dbi_metric_usdigital_arpu_$: '美国线上付费玩家人均平均消费（美元）',
  dbi_metric_digital_arpu_dollor_tips: '数字 ARPPU(美元) 仅在选择美国时可用。',
  dbi_metric_ast_$: '单笔交易消费均值（美元）',
  dbi_metric_rpd_$: '每下载收入（美元）',
  dbi_metric_revenue_per_download_$: '平均每下载付费（美元）',

  dbi_metric_steam_pcu: 'Steam PCU',
  dbi_metric_steam_acu: 'Steam ACU',
  dbi_metric_steam_price$: 'Steam价格(美元)',
  dbi_metric_steam_revenue: 'Steam收入(美元)',
  dbi_metric_steam_cumulative_revenue: 'Steam累计收入(美元)',
  dbi_metric_steam_units: 'Steam销量',
  dbi_metric_steam_cumulative_units: 'Steam累计销量',
  dbi_metric_steam_weighted_price$: 'Steam加权价格(美元)',
  dbi_metric_steamdata: 'Steam数据',
  dbi_metric_steam_followers: 'Steam关注人数',
  dbi_metric_steam_reviews: 'Steam评论数量',
  dbi_metric_vgi_steam_pcu: 'Steam PCU',
  dbi_metric_vgi_steam_acu: 'Steam ACU',
  dbi_metric_vgi_steam_followers: 'Steam关注人数',
  dbi_metric_vgi_steam_reviews: 'Steam评论数量',
  dbi_metric_vgi_steam_est_revenue: 'Steam本体收入(美元)',
  dbi_metric_vgi_steam_cumulative_revenue: 'Steam累计收入(美元)',
  dbi_metric_vgi_steam_units: 'Steam销量',
  dbi_metric_vgi_steam_cumulative_units: 'Steam累计销量',
  dbi_metric_vgi_steam_daily_wishlist: 'Steam每天新增愿望单人数',
  dbi_metric_vgi_steam_lifetime_wishlist: 'Steam总愿望单人数',
  dbi_metric_vgi_steam_price: 'Steam价格(美元)',
  dbi_metric_vgi_lifetime_weighted_price: 'Steam全生命周期加权价格(美元)',
  dbi_metric_vgi_steam_playtime: 'Steam平均游玩时间(分钟)',
  dbi_metric_vgi_est_revenue: 'Steam本体收入(美元)',
  dbi_metric_vgi_cumulative_revenue: 'Steam累计收入(美元)',
  dbi_metric_vgi_units: 'Steam销量',
  dbi_metric_vgi_cumulative_units: 'Steam累计销量',
  dbi_metric_vgi_daily_wishlist: 'Steam每日新增愿望单人数',
  dbi_metric_vgi_lifetime_wishlist: 'Steam总愿望单人数',
  dbi_metric_vgi_price: 'Steam价格(美元)',
  dbi_metric_vgi_weighted_price: 'Steam加权价格(美元)',
  dbi_metric_vgi_playtime: 'Steam平均游玩时间(分钟)',
  dbi_metric_vgi_followers: 'Steam总关注人数',
  dbi_metric_vgi_players_by_country: 'Steam玩家国家分布',

  dbi_metric_gsd_digital_units: '线上销量',
  dbi_metric_gsd_physical_units: '零售销量',
  dbi_metric_gsd_digital_revenue_euro: '线上收入（欧元）',
  dbi_metric_gsd_physical_revenue_euro: '零售收入（欧元）',
  dbi_metric_gsd_sales_date: `GSD销售数据`,
  dbi_metric_metacritic: `MetaCritic评分`,
  dbi_metric_metacritic_global: `MetaCritic评分(全球)`,
  dbi_metric_physical_units: '零售销量',
  //
  // dbi_metric_digitalRevenue_trends: 'Mscience线上收入(美国/美元)',
  dbi_metric_digitalRevenue_trends: 'Mscience线上收入(美元)',
  dbi_metric_mscience_lifetime_digital_revenue_trends: 'MScience历史总收入($)',
  dbi_metric_mscience_lifetime_digital_units_trends: 'MScience历史线上总销量',
  dbi_metric_physical_revenue_trends: 'NPD零售收入(美国/美元)',
  dbi_metric_gsd_digital_revenue_euro_trends: 'GSD线上收入(欧元)',
  dbi_metric_gsd_physical_revenue_euro_trends: 'GSD 零售收入(欧元)',
  dbi_metric_jptb_cumulative_revenue_trends: 'Steam累计收入(美元)',
  // dbi_metric_gsd_digital_units_trends: 'Mscience线上销量(美国)',
  dbi_metric_gsd_digital_units_trends: 'Mscience线上销量',
  dbi_metric_gsd_physical_units_trends: 'NPD零售销量(美国)',
  dbi_metric_gsd_digital_units_units_trends: 'GSD线上销量',
  dbi_metric_gsd_physical_units_gsd: 'GSD零售销量',
  dbi_metric_lifetime_weighted_price_trends: '全生命周期加权价格(美元)', // todp
  dbi_metric_playtime_steam: 'Steam平均游玩时间(分钟)',
  dbi_metric_ast_us: 'Mscience线上AST收益(美元)',
  dbi_metric_digitalARPPU_trends: 'Mscience线上ARPPU收益(美元)',
  dbi_metric_no_update: '无更新指标',
  dbi_metric_playertime: '游玩时间',
  dbi_metric_metric_set: '指标组',
  dbi_metric_customized: '自定义',
  dbi_metric_source_steam_pcu: 'Steam PCU',
  dbi_metric_source_steam_acu: 'Steam ACU',

  dbi_metric_combine_alinea_analytics_calibration_lifetime_units_revenue: '累计收入',
  dbi_metric_combine_alinea_analytics_calibration_lifetime_units: '累计销量',
  dbi_metric_combine_alinea_analytics_calibration_total_players: '总玩家数',
  dbi_metric_combine_alinea_analytics_calibration_lifetime_wishlist: '累计愿望单数',
  dbi_metric_combine_alinea_analytics_calibration_budget: '总预算',
  dbi_metric_combine_alinea_analytics_calibration_budget_marketing: '营销预算',
  dbi_metric_combine_alinea_analytics_calibration_budget_development: '研发预算',
};
